export default __webpack_public_path__ + "static/media/VME_Home.6486f1e8.png";